module.exports = "<p>\r\n  Permissão negada! \r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/permissao-negada/permissao-negada.component.html
// module id = ./src/app/permissao-negada/permissao-negada.component.html
// module chunks = main